/******/ (() => { // webpackBootstrap
/******/ 	"use strict";
/*!***********************!*\
  !*** ./src/js/app.js ***!
  \***********************/


(function () {
  if (window.lightHouse) return;
  function debounce(fn, delay) {
    let t;
    return () => {
      clearTimeout(t);
      t = setTimeout(fn, delay);
    };
  }
  const body = document.body;
  const header = document.querySelector(".header");
  const headerToggle = document.querySelector(".header-toggle");
  const headerModal = document.querySelector(".header-modal");
  const headerOverflow = document.querySelector(".header-overflow");
  const headerHeight = header ? header.offsetHeight : 0;
  const searchModal = document.querySelector(".header-search__modal");
  const cartModal = document.querySelector(".header-cart__modal");
  const cartModalBox = document.querySelectorAll(".header-cart__modal-box");
  const headerMenu = document.querySelector(".header-menu");
  const headerMenuModals = document.querySelectorAll(".header-menu__modal");
  const headerDropdowns = document.querySelectorAll(".header-menu a.is-dropdown");
  const headerLangs = document.querySelectorAll(".header-lang, .header-modal__lang");
  function closeHeaderMenuDesktop() {
    headerDropdowns.forEach(el => el.classList.remove("active"));
    headerMenuModals.forEach(el => el.classList.remove("show"));
    body.classList.remove("no-scroll");
  }
  const searchInput = document.querySelector(".js-search");
  let activeBlock = null;
  const animateIn = el => {
    if (!el) return;
    if (typeof gsap === "undefined") return;
    gsap.fromTo(el, {
      autoAlpha: 0,
      y: 12
    }, {
      autoAlpha: 1,
      y: 0,
      duration: 0.35,
      ease: "power2.out",
      clearProps: "all"
    });
  };
  const animateGrid = grid => {
    if (!grid || !grid.children.length) return;
    if (typeof gsap === "undefined") return;
    gsap.fromTo(grid.children, {
      autoAlpha: 0,
      y: 10
    }, {
      autoAlpha: 1,
      y: 0,
      duration: 0.35,
      stagger: 0.05,
      ease: "power2.out",
      clearProps: "all"
    });
  };
  if (searchInput) {
    searchInput.addEventListener("input", () => {
      const value = searchInput.value.length;
      const allBlocks = document.querySelectorAll(".header-search__modal-title, .header-search__modal-grid, [data-search]");

      // Hide all
      allBlocks.forEach(el => el.classList.add("hidden"));
      let target = null;
      if (value === 0) {
        target = document.querySelector('[data-search="default"]');
      } else if (value < 3) {
        target = document.querySelector('[data-search="loading"]');
      } else if (value > 10) {
        target = document.querySelector('[data-search="empty"]');
      } else {
        target = document.querySelector(".header-search__modal-grid");
      }

      // Prevent re-animating same block
      if (target && target !== activeBlock) {
        target.classList.remove("hidden");
        if (target.classList.contains("header-search__modal-grid")) {
          animateGrid(target);
        } else {
          animateIn(target);
        }
        activeBlock = target;
      }
    });
  }
  let lastWidth = window.innerWidth;
  window.addEventListener("resize", debounce(() => {
    if (window.innerWidth !== lastWidth) {
      lastWidth = window.innerWidth;
      if (window.innerWidth >= 1200 && headerModal?.classList.contains("show")) {
        closeHeaderMenuDesktop();
      }
    }
  }, 150));
  const filterModal = document.querySelector(".catalog-filter__modal");
  const overflow = document.querySelector(".overflow");
  document.querySelector(".catalog-filter__modal-box form")?.addEventListener("reset", e => {
    const form = e.target;
    requestAnimationFrame(() => {
      form.querySelectorAll(".catalog-filter__accordion").forEach(updateAccordionFilteredState);
    });
  });
  const catalogSort = document.querySelector(".catalog-sort");
  const catalogSortModal = document.querySelector(".catalog-sort__modal");

  /* - - - - - - - - - - - - - -       init fancybox       - - - - - - - - - - - - - - - */
  function initFancybox() {
    if (typeof Fancybox === "undefined") return;
    if (typeof Fancybox.unbind === "function") {
      Fancybox.unbind("[data-fancybox]");
    }
    Fancybox.bind("[data-fancybox]", {
      autoFocus: false,
      placeFocusBack: false,
      dragToClose: false,
      closeExisting: true,
      Thumbs: false,
      Carousel: {
        transition: "slide"
      },
      tpl: {
        closeButton: '<button data-fancybox-close class="f-button is-close-btn" title="{{CLOSE}}">' + '<span class="icon icon-i-close"></span>' + "</button>"
      },
      on: {
        init: fancybox => {
          fancybox.on("Carousel.ready", (fancybox, carousel) => {
            const prevBtn = carousel.getContainer().querySelector(".f-button.is-prev");
            const nextBtn = carousel.getContainer().querySelector(".f-button.is-next");
            if (prevBtn) {
              prevBtn.innerHTML = '<span class="icon icon-i-arrow-left"></span>';
              prevBtn.title = fancybox.getOptions().l10n.PREV;
            }
            if (nextBtn) {
              nextBtn.innerHTML = '<span class="icon icon-i-arrow-right"></span>';
              nextBtn.title = fancybox.getOptions().l10n.NEXT;
            }
          });
        }
      }
    });
  }

  /* - - - - - - - - - - - - - -       init mCustomScrollbar       - - - - - - - - - - - - - - - */
  function initScrollbar() {
    $(".js-scrollbar").each(function () {
      const $el = $(this);
      if ($el.data("scrollbarInit") === 1) return;
      $el.data("scrollbarInit", 1);
      $el.mCustomScrollbar({
        scrollButtons: {
          enable: false
        },
        autoHideScrollbar: false,
        scrollInertia: 600,
        mouseWheel: {
          enable: true,
          scrollAmount: 100
        },
        keyboard: {
          enable: true
        },
        advanced: {
          updateOnContentResize: true
        }
      });
    });
  }

  /* - - - - - - - - - - - - - -       input validate       - - - - - - - - - - - - - - - */
  function setInput() {
    $('input:not(.btn):not([type="checkbox"]):not([type="radio"]):not([type="submit"]):not([type="reset"]), textarea, select').each(function () {
      const $this = $(this);
      const $parent = $this.closest(".form-group");
      const isPlaceholder = $this.attr("placeholder") ? true : false;
      const isDataPlaceholder = $this.attr("data-placeholder") ? true : false;
      const isAutofill = $this[0].matches(":autofill") === true ? true : false;
      if ($this.val() !== "" || isPlaceholder || isDataPlaceholder || isAutofill) {
        $parent.addClass("filled");
      }
    });
  }
  setInput(setInput, 10);
  $(document).on("focus", 'input:not(.btn):not([type="checkbox"]):not([type="radio"]):not([type="submit"]):not([type="reset"]), textarea, select', function () {
    const $parent = $(this).closest(".form-group");
    $parent.addClass("filled");
  });
  $(document).on("blur", 'input:not(.btn):not([type="checkbox"]):not([type="radio"]):not([type="submit"]):not([type="reset"]), textarea', function () {
    $('input:not(.btn):not([type="checkbox"]):not([type="radio"]):not([type="submit"]):not([type="reset"]), textarea').each(function () {
      const $this = $(this);
      const $parent = $this.closest(".form-group");
      const isPlaceholder = $this.attr("placeholder") ? true : false;
      if ($this.val() === "" && !$this.is(":focus") && !isPlaceholder) {
        $parent.removeClass("filled");
      }
    });
  });
  $(document).on("input", 'input:not(.btn):not([type="checkbox"]):not([type="radio"]):not([type="submit"]):not([type="reset"])[data-required], textarea[data-required]', function () {
    const $this = $(this);
    const $parent = $this.closest(".form-group");
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    if ($this.val() === "") {
      $parent.addClass("has-error");
    } else {
      if ($this.attr("type") === "email") {
        if (!emailRegex.test($this.val())) {
          $parent.addClass("has-error");
        } else {
          $parent.removeClass("has-error");
        }
      } else {
        const maxCount = $this.data("count");
        if (maxCount) {
          const count = $this.val().length;
          if (count > maxCount) {
            $parent.addClass("has-error");
          } else {
            $parent.removeClass("has-error");
          }
        } else {
          $parent.removeClass("has-error");
        }
      }
    }
  });
  const textareaAll = document.querySelectorAll("textarea");
  function checkOverflow(el) {
    const scrollTop = el.scrollTop;
    el.classList.toggle("is-scroll", scrollTop > 4);
  }
  let resizeTimeout;
  function handleResize() {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
      textareaAll.forEach(el => checkOverflow(el));
    }, 150);
  }
  textareaAll.forEach(el => {
    checkOverflow(el);
    el.addEventListener("input", () => checkOverflow(el));
    el.addEventListener("paste", () => setTimeout(() => checkOverflow(el), 0));
    el.addEventListener("scroll", () => checkOverflow(el));
  });
  window.addEventListener("resize", handleResize);

  /* - - - - - - - - - - - - - -       init select2       - - - - - - - - - - - - - - - */
  const lang = $("html").attr("lang").slice(0, 2).toLowerCase();
  const direction = $("html").css("direction");
  function initSelect() {
    $(".js-select").each(function () {
      const $select = $(this);
      if ($select.hasClass("select2-hidden-accessible")) return;
      const isMultiple = $select.prop("multiple");
      const isSearch = $select.data("search");
      $select.select2({
        language: lang,
        width: "100%",
        closeOnSelect: !isMultiple,
        placeholder: $select.data("placeholder") || "",
        minimumResultsForSearch: isSearch ? 0 : -1
      }).on("select2:open", function (e) {
        const $parent = e.target.closest(".form-group");
        const isModal = e.target.closest(".modal");
        $($parent).addClass("filled");
        if (isModal) {
          $(".select2-container .select2-dropdown").addClass("select2-dropdown--modal");
        }
      }).on("select2:close", function (e) {
        const $parent = $(e.target).closest(".form-group");
        const value = e.target.value;
        const isPlaceholder = $(e.target).attr("data-placeholder") ? true : false;
        if (value === "" && !isPlaceholder) {
          $parent.removeClass("filled");
        }
      }).on("select2:select", function (e) {
        const hasValue = Boolean(e.params?.data);
        const $parent = $(e.target).closest(".form-group");
        $parent.toggleClass("has-error", !hasValue);
      });
    });
  }

  /* - - - - - - - - - - - - - -       fit text to width       - - - - - - - - - - - - - - - */
  function fitTextToWidth(el) {
    if (!el || !el.parentElement) return;
    const parent = el.parentElement;
    const parentStyles = getComputedStyle(parent);
    const padding = parseFloat(parentStyles.paddingLeft) + parseFloat(parentStyles.paddingRight);
    const maxWidth = window.innerWidth - padding;
    let min = 1;
    let max = 100;
    let best = min;

    // binary search → мінімум reflow
    while (min <= max) {
      const mid = (min + max) / 2;
      el.style.fontSize = `${mid}vw`;
      if (el.offsetWidth <= maxWidth) {
        best = mid;
        min = mid + 0.1;
      } else {
        max = mid - 0.1;
      }
    }
    el.style.fontSize = `${best}vw`;
  }
  function initFitText() {
    document.querySelectorAll(".js-size-settings").forEach(el => {
      requestAnimationFrame(() => fitTextToWidth(el));
    });
  }
  initFitText();

  /* - - - - - - - - - - - - - -       init count price       - - - - - - - - - - - - - - - */
  function getNum(val) {
    if (typeof val !== "string") val = String(val || "");
    const match = val.match(/-?\d+\.?\d*/);
    return match ? parseInt(match[0], 10) : "";
  }
  function setWidthField(field) {
    if (!field) return;
    if (!field._padding) {
      const styles = getComputedStyle(field);
      field._padding = (parseFloat(styles.paddingLeft) || 0) + (parseFloat(styles.paddingRight) || 0);
    }
    const value = field.value || "";
    const symbolCount = value.length;
    const widthPx = symbolCount * 10 - symbolCount + 1 + field._padding;
    field.style.width = `${widthPx / 16}rem`;
  }

  /* =========================
    INIT COUNT
  ========================= */
  function initCount() {
    function getConfig(field) {
      return {
        min: parseInt(field.dataset.min, 10),
        max: parseInt(field.dataset.max, 10),
        prefix: field.dataset.prefix || "",
        postfix: field.dataset.postfix ? " " + field.dataset.postfix : ""
      };
    }
    function syncState(countEl) {
      const field = countEl.querySelector(".count-value");
      const inc = countEl.querySelector(".count-inc");
      const dec = countEl.querySelector(".count-dec");
      if (!field) return;
      const {
        min,
        max
      } = getConfig(field);
      let value = getNum(field.value);
      inc.classList.remove("disabled");
      dec.classList.remove("disabled");
      if (value <= min) dec.classList.add("disabled");
      if (value >= max) inc.classList.add("disabled");
      setWidthField(field);
    }
    function setValue(field, value) {
      const {
        min,
        max,
        prefix,
        postfix
      } = getConfig(field);
      value = Math.max(min, Math.min(max, value));
      field.value = prefix + value + postfix;
      syncState(field.closest(".count"));
    }
    function ensureInit(countEl) {
      if (countEl.dataset.countInit === "1") return;
      countEl.dataset.countInit = "1";
      syncState(countEl);
    }

    // document.addEventListener("click", (e) => {
    // 	const btn = e.target.closest(".count-inc, .count-dec");
    // 	if (!btn) return;

    // 	e.preventDefault();
    // 	if (btn.classList.contains("disabled")) return;

    // 	const countEl = btn.closest(".count");
    // 	ensureInit(countEl);
    // 	const field = countEl.querySelector(".count-value");
    // 	if (!field) return;

    // 	let value = getNum(field.value);
    // 	if (value === "") value = parseInt(field.dataset.min, 10);

    // 	value += btn.classList.contains("count-inc") ? 1 : -1;
    // 	setValue(field, value);
    // });

    // document.addEventListener("input", (e) => {
    // 	if (!e.target.classList.contains("count-value")) return;

    // 	const field = e.target;
    // 	const countEl = field.closest(".count");
    // 	ensureInit(countEl);
    // 	const { min, max } = getConfig(field);

    // 	let value = getNum(field.value);
    // 	if (value === "" || isNaN(value)) return;

    // 	value = Math.max(min, Math.min(max, value));
    // 	field.value = value;

    // 	syncState(countEl);
    // });

    // document.addEventListener("focusin", (e) => {
    // 	if (!e.target.classList.contains("count-value")) return;

    // 	const field = e.target;
    // 	const countEl = field.closest(".count");
    // 	ensureInit(countEl);
    // 	if (field.readOnly) return;

    // 	field.value = getNum(field.value) || "";
    // 	setWidthField(field);
    // });

    // document.addEventListener("focusout", (e) => {
    // 	if (!e.target.classList.contains("count-value")) return;

    // 	const field = e.target;
    // 	const { min, prefix, postfix } = getConfig(field);

    // 	let value = getNum(field.value);
    // 	if (value === "" || isNaN(value)) value = min;

    // 	field.value = prefix + value + postfix;
    // 	syncState(field.closest(".count"));
    // });

    const io = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) return;
        ensureInit(entry.target);
        io.unobserve(entry.target);
      });
    }, {
      rootMargin: "100px"
    });
    document.querySelectorAll(".count").forEach(el => io.observe(el));
  }
  initCount();

  /* =========================
    IONRANGESLIDER HELPERS
  ========================= */
  function prettify(num) {
    const n = num.toString();
    return n.replace(/(\d{1,3}(?=(?:\d\d\d)+(?!\d)))/g, "$1 ");
  }

  /* =========================
    INIT IONRANGESLIDER
  ========================= */
  function initIonRangeSlider(scope = document) {
    const ranges = scope.querySelectorAll(".js-range");
    ranges.forEach(rangeEl => {
      const $range = $(rangeEl);
      if ($range.data("ionRangeSlider")) return;
      const parent = rangeEl.closest(".range-box");
      if (!parent) return;
      const inputFrom = parent.querySelector(".range-box__value-from");
      const inputTo = parent.querySelector(".range-box__value-to");
      const min = parseInt(rangeEl.dataset.min, 10);
      const max = parseInt(rangeEl.dataset.max, 10);
      const from = parseInt(rangeEl.dataset.from, 10);
      const to = parseInt(rangeEl.dataset.to, 10);
      let instance = null;
      function updateInputs(data) {
        if (!inputFrom || !inputTo) return;
        inputFrom.value = prettify(data.from);
        inputTo.value = prettify(data.to);
      }
      $range.ionRangeSlider({
        type: "double",
        grid: false,
        hide_from_to: true,
        hide_min_max: true,
        min,
        max,
        from,
        to,
        onStart: updateInputs,
        onChange: updateInputs
      });
      instance = $range.data("ionRangeSlider");
      if (!instance) return;

      // 🔹 FROM input
      inputFrom.addEventListener("input", () => {
        let val = parseInt(inputFrom.value.replace(/\D+/g, ""), 10);
        if (isNaN(val)) val = min;
        const currentTo = parseInt(inputTo.value.replace(/\D+/g, ""), 10);
        val = Math.max(min, Math.min(val, currentTo));
        instance.update({
          from: val
        });
        inputFrom.value = prettify(val);
      });
      inputFrom.addEventListener("blur", () => {
        let val = parseInt(inputFrom.value.replace(/\D+/g, ""), 10);
        if (!val || val < min) val = min;
        inputFrom.value = prettify(val);
      });

      // 🔹 TO input
      inputTo.addEventListener("input", () => {
        let val = parseInt(inputTo.value.replace(/\D+/g, ""), 10);
        if (isNaN(val)) val = max;
        const currentFrom = parseInt(inputFrom.value.replace(/\D+/g, ""), 10);
        val = Math.min(max, Math.max(val, currentFrom));
        instance.update({
          to: val
        });
        inputTo.value = prettify(val);
      });
      inputTo.addEventListener("blur", () => {
        let val = parseInt(inputTo.value.replace(/\D+/g, ""), 10);
        if (!val || val > max) val = max;
        inputTo.value = prettify(val);
      });
    });
  }

  /* - - - - - - - - - - - - - -       rebuild catalog sort       - - - - - - - - - - - - - - - */
  function rebuildCatalogSort() {
    const $catalogSort = $(".catalog-sort");
    const $catalogSortModal = $(".catalog-sort__modal").detach();
    if (window.matchMedia("(max-width: 767px)").matches) {
      $("body").append($catalogSortModal);
    } else {
      $catalogSort.append($catalogSortModal);
    }
  }

  /* - - - - - - - - - - - - - -       product gallery slider       - - - - - - - - - - - - - - - */
  // function rebuildProduct() {
  // 	const $productHead = $(".product-head").detach();
  // 	const $productInner = $(".product-inner");
  // 	const $productContent = $(".product-content");
  // 	if (window.matchMedia("(max-width: 1199px)").matches) {
  // 		$productInner.prepend($productHead);
  // 	} else {
  // 		$productContent.prepend($productHead);
  // 	}
  // }

  $(function () {
    function initPagePlugins() {
      initFancybox();
      if ($(".js-range").length) initIonRangeSlider(document);
      if ($(".js-select").length) initSelect();
      // Custom scrollbars live inside closed overlays (cart popup, menus),
      // so measuring them during boot only adds main-thread work. Init when
      // idle after load, or on the first interaction — whichever comes first.
      if ($(".js-scrollbar").length) {
        let scrollbarsInited = false;
        const initScrollbarsOnce = () => {
          if (scrollbarsInited) return;
          scrollbarsInited = true;
          initScrollbar();
        };
        // First interaction only: the idle-after-load warmup still landed
        // inside the TBT window on throttled mobile (~650ms task). Scrollbars
        // live in overlays that can only be reached via pointer or keyboard,
        // so the capturing first-interaction init always runs before any
        // overlay opens, and pages that are never touched never pay it.
        document.addEventListener("pointerdown", initScrollbarsOnce, { once: true, capture: true });
        document.addEventListener("keydown", initScrollbarsOnce, { once: true, capture: true });
      }
    }
    initPagePlugins();
    function toggleSubscribe(emailInput) {
      if (!emailInput) return;
      const subscribeBox = emailInput.closest(".footer-box__subscribe");
      if (!subscribeBox) return;
      subscribeBox.classList.toggle("show", emailInput.value.trim().length > 0);
    }
	  const emailInput = document.querySelector('.footer-box__subscribe input[type="email"]');
    if (emailInput) {
      toggleSubscribe(emailInput);
      emailInput.addEventListener("input", e => toggleSubscribe(e.target));
    }

    /* =========================
      IDLE CALLBACK
    ========================= */
    const requestIdle = window.requestIdleCallback || function (cb) {
      const start = Date.now();
      return setTimeout(() => {
        cb({
          didTimeout: false,
          timeRemaining: () => Math.max(0, 50 - (Date.now() - start))
        });
      }, 1);
    };
    const cancelIdle = window.cancelIdleCallback || clearTimeout;

    /* =========================
      SWIPER CACHE
    ========================= */
    const swiperMap = new WeakMap();

    /* =========================
      CLONE SLIDES
    ========================= */
    function cloneSlides(container, dublicate = false) {
      const wrapper = container.querySelector(".swiper-wrapper");
      if (!wrapper || wrapper.dataset.cloned) return;
      const slides = wrapper.children;
      const count = slides.length;
      if (count <= 1) return;
      const fragmentStart = document.createDocumentFragment();
      const fragmentEnd = document.createDocumentFragment();
      if (count === 2) {
        fragmentStart.append(slides[0].cloneNode(true), slides[1].cloneNode(true));
        fragmentEnd.append(slides[0].cloneNode(true), slides[1].cloneNode(true));
      } else if (count === 3) {
        Array.from(slides).forEach(s => fragmentStart.append(s.cloneNode(true)));
        Array.from(slides).forEach(s => fragmentEnd.append(s.cloneNode(true)));
      }
      if (fragmentStart.childElementCount > 0) {
        wrapper.prepend(fragmentStart);
        wrapper.append(fragmentEnd);
      }
      if (dublicate) {
        wrapper.innerHTML += wrapper.innerHTML;
      }
      wrapper.dataset.cloned = "true";
    }
    const onSliderUpdate = debounce(container => {
      if (!container) return;
      if (typeof processTagsList === "function") {
        container.querySelectorAll(".js-tags").forEach(processTagsList);
      }
    }, 60);

    /* =========================
      INIT SWIPER CORE
    ========================= */
	  function createSwiper(container) {
		  if (swiperMap.has(container)) return;
		  const isMobile = window.matchMedia("(max-width: 767px)").matches;
		  const swiper = new Swiper(container, {
			  loop: !isMobile,
			  speed: 800,
			  slidesPerView: "auto",
			  spaceBetween: 32,
			  centeredSlides: true,
			  watchSlidesProgress: true,
			  watchOverflow: true,
			  normalizeSlideIndex: true,
			  preloadImages: false,
			  lazy: true,
			  observer: false,
			  observeParents: false,
			  navigation: {
				  enabled: false,
				  nextEl: container.querySelector(".swiper-button-next"),
				  prevEl: container.querySelector(".swiper-button-prev")
			  },
			  breakpoints: {
				  1200: {
					  navigation: {
						  enabled: true
					  }
				  },
				  768: {
					  spaceBetween: 32,
					  centeredSlides: true
				  },
				  0: {
					  spaceBetween: 8,
					  centeredSlides: true
				  }
			  },
			  resistance: false,
			  touchRatio: 1,
			  touchAngle: 45,
			  on: {
				  init() {
					  container.classList.add("show");
					  onSliderUpdate(container);
				  }
			  }
		  });
		  swiperMap.set(container, swiper);
	  }

    /* =========================
      LAZY OBSERVER
    ========================= */
    const swiperObserver = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const container = entry.target;
          window.requestAnimationFrame(() => {
            createSwiper(container);
          });
          observer.unobserve(container);
        }
      });
    }, {
      rootMargin: "400px 0px",
      threshold: 0.01
    });
    document.querySelectorAll(".js-section-slider").forEach(el => {
      if (window.lightHouse) {
        el.classList.add("lighthouse");
      }
      swiperObserver.observe(el);
    });

    /* =========================
      OTHER SLIDER (SINGLE)
    ========================= */
    const otherSlider = document.querySelector(".js-section-slider-other");
    if (otherSlider) {
      swiperObserver.observe(otherSlider);
    }
    function isElementVisible(el) {
      return !!(el && el.offsetParent !== null);
    }
    const productGalleryState = {
      inited: false,
      idleId: null
    };

    /* =========================
      INIT PRODUCT GALLERY
    ========================= */
    function initProductGallery(priority = "idle") {
      if (productGalleryState.inited) return;
      const big = document.querySelector(".js-product-gallery-big");
      const thumb = document.querySelector(".js-product-gallery-thumbnail");
      if (!big || !thumb) return;
      if (!isElementVisible(big) || !isElementVisible(thumb)) return;
      const next = thumb.nextElementSibling?.querySelector(".swiper-button-next");
      const prev = thumb.nextElementSibling?.querySelector(".swiper-button-prev");
      const init = () => {
        const thumbSwiper = new Swiper(thumb, {
          loop: true,
          speed: 1000,
          slidesPerView: "auto",
          // centeredSlides: true,
          slideToClickedSlide: true,
          observer: false,
          observeParents: false,
          navigation: {
            enabled: true,
            nextEl: next,
            prevEl: prev
          }
        });
        const bigSwiper = new Swiper(big, {
          loop: true,
          speed: 1000,
          effect: "fade",
          fadeEffect: {
            crossFade: true
          },
          observer: false,
          observeParents: false,
          thumbs: {
            swiper: thumbSwiper
          }
        });
        const checkAndCenterSlides = () => {
          const swiperWrapper = thumb.querySelector(".swiper-wrapper");
          const slides = thumb.querySelectorAll(".swiper-slide:not(.swiper-slide-duplicate)");
          if (!swiperWrapper || slides.length === 0) return;
          const containerWidth = thumb.offsetWidth;
          let totalWidth = 0;
          slides.forEach((slide, index) => {
            totalWidth += slide.offsetWidth;
            if (index < slides.length - 1) {
              const spaceBetween = parseInt(window.getComputedStyle(slide).marginRight) || 0;
              totalWidth += spaceBetween;
            }
          });
          if (totalWidth < containerWidth) {
            thumbSwiper.params.loop = false;
            thumbSwiper.loopDestroy();
            swiperWrapper.style.justifyContent = "center";
            if (next) next.style.display = "none";
            if (prev) prev.style.display = "none";
          } else {
            swiperWrapper.style.justifyContent = "";
            if (next) next.style.display = "";
            if (prev) prev.style.display = "";
          }
        };
        thumbSwiper.on("init", checkAndCenterSlides);
        thumbSwiper.on("resize", checkAndCenterSlides);
        setTimeout(checkAndCenterSlides, 50);
        productGalleryState.inited = true;
        big.classList.add("show");
        thumb.classList.add("show");
      };
      if (priority === "high") {
        init();
        return;
      }
      if (productGalleryState.idleId) {
        cancelIdle(productGalleryState.idleId);
      }
      productGalleryState.idleId = requestIdle(d => {
        init();
        productGalleryState.idleId = null;
      });
    }
    const productGalleryObserver = new IntersectionObserver(entries => {
      entries.forEach(e => {
        if (!e.isIntersecting) return;
        initProductGallery("idle");
        productGalleryObserver.disconnect();
      });
    }, {
      rootMargin: "200px"
    });
    const productGalleryBig = document.querySelector(".js-product-gallery-big");
    if (productGalleryBig) {
      productGalleryObserver.observe(productGalleryBig);
    }

    /* =========================
      INIT OTHER PRODUCT
    ========================= */
    function initOtherProductsSlider(container, priority = "idle") {
      if (swiperMap.has(container)) {
        swiperMap.get(container).update?.();
        return;
      }
      const init = () => {
        const swiper = new Swiper(container, {
          loop: false,
          speed: 1000,
          slidesPerView: 1,
          navigation: {
            enabled: false,
            nextEl: container.querySelector(".swiper-button-next"),
            prevEl: container.querySelector(".swiper-button-prev")
          },
          breakpoints: {
            1200: {
              slidesPerView: 4
            },
            992: {
              slidesPerView: 3.2
            },
            768: {
              centeredSlides: false,
              slidesPerView: 2.4
            },
            0: {
              centeredSlides: true,
              slidesPerView: 1.2
            }
          },
          resistance: false,
          freeMode: false,
          touchRatio: 1,
          touchAngle: 45,
          longSwipesRatio: 0.5,
          watchOverflow: true,
          normalizeSlideIndex: true,
          on: {
            init() {
              onSliderUpdate(container);
            },
            slideChangeTransitionEnd() {
              onSliderUpdate(container);
            }
          }
        });
        swiperMap.set(container, swiper);
        container.classList.add("show");
      };
      init();
      return;

      // if (priority === 'high') init();
      // else {
      // 	container.__idleId = requestIdle(d => {
      // 		if (d.timeRemaining() > 10 || d.didTimeout) init();
      // 		else initOtherProductsSlider(container, 'idle');
      // 	});
      // }
    }
    const otherProductsObserver = new IntersectionObserver(entries => {
      entries.forEach(e => {
        if (!e.isIntersecting) return;
        initOtherProductsSlider(e.target);
        otherProductsObserver.unobserve(e.target);
      });
    }, {
      rootMargin: "200px"
    });
    document.querySelectorAll(".js-other-products-slider").forEach(el => otherProductsObserver.observe(el));

    /* =========================
      INIT OTHER PRODUCT
    ========================= */
    function initArticleGallery(container, priority = "idle") {
      if (swiperMap.has(container)) return;
      const init = () => {
        const isMobile = window.matchMedia("(max-width: 767px)").matches;
        const swiper = new Swiper(container, {
          loop: !isMobile,
          speed: 1000,
          slidesPerView: "auto",
          navigation: {
            nextEl: container.querySelector(".swiper-button-next"),
            prevEl: container.querySelector(".swiper-button-prev")
          },
          pagination: {
            el: container.querySelector(".swiper-pagination"),
            type: "fraction"
          },
          watchOverflow: true
        });
        swiperMap.set(container, swiper);
        container.classList.add("show");
      };
      if (priority === "high") init();else {
        container.__idleId = requestIdle(d => {
          if (d.timeRemaining() > 10 || d.didTimeout) init();else initArticleGallery(container, "idle");
        });
      }
    }
    const articleGalleryObserver = new IntersectionObserver(entries => {
      entries.forEach(e => {
        if (!e.isIntersecting) return;
        initArticleGallery(e.target);
        articleGalleryObserver.unobserve(e.target);
      });
    }, {
      rootMargin: "200px"
    });
    document.querySelectorAll(".js-article-gallery-slider").forEach(el => articleGalleryObserver.observe(el));

    /* =========================
      TABS SCROLL CHECK
    ========================= */
    function getScrollTabs() {
      document.querySelectorAll(".tabs").forEach(tabs => {
        const list = tabs.querySelector(".tabs-list ul");
        if (!list) return;
        const isScroll = Math.ceil(list.scrollWidth) > Math.ceil(list.offsetWidth);
        list.classList.toggle("is-scroll", isScroll);
      });
    }
    if (document.querySelector(".tabs")) {
      getScrollTabs();
      window.addEventListener("resize", debounce(getScrollTabs, 150));
    }

    // 	/* =========================
    //    TABS
    // ========================= */
    // 	document.addEventListener("click", function (e) {
    // 		const link = e.target.closest(".js-tabs .tabs-list a");
    // 		if (!link) return;

    // 		e.preventDefault();
    // 		if (link.classList.contains("active")) return;

    // 		const target = link.dataset.tab;
    // 		const tabs = link.closest(".tabs");
    // 		if (!tabs) return;

    // 		const tabsList = link.closest(".tabs-list");
    // 		const tabsContent = tabs.querySelector(".tabs-content");
    // 		const section = link.closest(".section.featured");

    // 		if (section && target) {
    // 			const classes = section.className.split(/\s+/);
    // 			const lastClass = classes[classes.length - 1];
    // 			if (lastClass) {
    // 				section.classList.remove(lastClass);
    // 				section.classList.add(target);
    // 			}
    // 		}

    // 		tabsList.querySelectorAll("a.active").forEach((a) => {
    // 			a.classList.remove("active");
    // 		});
    // 		link.classList.add("active");

    // 		tabsContent
    // 			.querySelectorAll(".tabs-content__box.show")
    // 			.forEach((box) => {
    // 				box.classList.remove("show");
    // 			});

    // 		const targetBox = tabsContent.querySelector(
    // 			`.tabs-content__box[data-tab="${target}"]`,
    // 		);

    // 		if (!targetBox) return;
    // 		targetBox.classList.add("show");

    // 		targetBox.querySelectorAll(".js-tags").forEach((list) => {
    // 			processTagsList(list);
    // 		});
    // 	});

    /* =========================
      TAGS HELPERS
    ========================= */
    function isVisible(el) {
      return !!(el && el.offsetParent !== null);
    }
    function getGapPx() {
      const fontSize = parseFloat(getComputedStyle(document.documentElement).fontSize) || 16;
      return 0.25 * fontSize;
    }

    /* =========================
      INIT TAGS
    ========================= */
    function processTagsList(list) {
      if (!list || !isVisible(list)) return;
      const oldOther = list.querySelector(".tag-other");
      if (oldOther) oldOther.remove();
      const tags = Array.from(list.querySelectorAll(".tag:not(.tag-other)"));
      if (!tags.length) return;
      const maxWidth = list.clientWidth;
      if (!maxWidth) return;
      const gap = getGapPx();
      tags.forEach(tag => {
        tag.style.display = "";
      });
      const firstTag = tags[0];
      const style = getComputedStyle(firstTag);
      const padding = parseFloat(style.paddingLeft) + parseFloat(style.paddingRight);
      const tagOtherWidth = padding * 2;
      // Read pass before any hiding: one layout for the whole list instead of
      // a forced reflow per tag from interleaved offsetWidth reads and
      // display writes. Sibling visibility does not change a tag's own width.
      const widths = tags.map(tag => tag.offsetWidth);
      let usedWidth = 0;
      let hiddenCount = 0;
      const hiddenTags = [];
      for (let i = 0; i < tags.length; i++) {
        const tag = tags[i];
        const w = widths[i];
        if (usedWidth + w + gap + tagOtherWidth > maxWidth) {
          hiddenCount++;
          hiddenTags.push(tag.cloneNode(true));
          tag.style.display = "none";
        } else {
          usedWidth += w + gap;
        }
      }
      list.dataset.tagsProcessed = "1";
      if (!hiddenCount) return;
      const other = document.createElement("span");
      other.className = "tag tag-other";
      other.textContent = `+${hiddenCount}`;
      const modal = document.createElement("div");
      modal.className = "tag-other__modal";
      hiddenTags.forEach(tag => modal.appendChild(tag));
      other.appendChild(modal);
      list.appendChild(other);
    }
    const tagsObserver = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) return;
        const list = entry.target;
        processTagsList(list);
        tagsObserver.unobserve(list);
      });
    }, {
      rootMargin: "200px",
      threshold: 0.01
    });
    // Process lazily as lists approach the viewport (rootMargin above) —
    // eagerly processing all lists at boot forced layout across the whole
    // page and produced a multi-second long task on mobile.
    document.querySelectorAll(".js-tags").forEach(list => {
      tagsObserver.observe(list);
    });
    const onResizeTags = debounce(() => {
      document.querySelectorAll(".js-tags").forEach(list => {
        if (list.dataset.tagsProcessed === "1" && isVisible(list)) {
          processTagsList(list);
        }
      });
    }, 120);
    window.addEventListener("resize", onResizeTags);

    /* - - - - - - - - - - - - - -       toggle header cart detais       - - - - - - - - - - - - - - - */
    $(".js-header-cart-details-toggle").on("click", function (e) {
      e.preventDefault();
      const $this = $(this);
      const $parent = $this.closest(".header-cart__details");
      const textShow = $this.attr("data-text-show");
      const textHide = $this.attr("data-text-hide");
      if (!$parent.hasClass("show")) {
        $this.find("span:not(.icon)").text(textHide);
        $parent.addClass("show");
        $parent.find(".header-cart__details-table").slideDown(600);
      } else {
        $this.find("span:not(.icon)").text(textShow);
        $parent.removeClass("show");
        $parent.find(".header-cart__details-table").slideUp(600);
      }
    });

    /* =========================
      CATEGORY SCROLL CHECK
    ========================= */
    function getScrollCategory() {
      document.querySelectorAll(".catalog-category").forEach(category => {
        const list = category.querySelector(".catalog-category__list");
        if (!list) return;
        const isScroll = Math.ceil(list.scrollWidth) > Math.ceil(list.offsetWidth);
        list.classList.toggle("is-scroll", isScroll);
      });
    }
    if (document.querySelector(".catalog-category")) {
      getScrollCategory();
      window.addEventListener("resize", debounce(getScrollCategory, 150));
    }

    /* - - - - - - - - - - - - - -       toggle catalog filter options       - - - - - - - - - - - - - - - */
    $(".js-catalog-filter-accordion").on("click", function (e) {
      const $this = $(this);
      const $parent = $this.closest(".catalog-filter__accordion");
      const $content = $parent.find(".catalog-filter__accordion-content");
      if (!$parent.hasClass("show")) {
        $parent.addClass("show");
        $content.slideDown(600);
      } else {
        if (!$(e.target).hasClass("js-catalog-filter-group-reset")) {
          $parent.removeClass("show");
          $content.slideUp(600);
        }
      }
    });

    /* - - - - - - - - - - - - - -       init rebuild catalog sort       - - - - - - - - - - - - - - - */
    if ($(".catalog-sort")) {
      rebuildCatalogSort();
      $(window).on("resize", rebuildCatalogSort);
    }

    /* - - - - - - - - - - - - - -       toggle product accordion       - - - - - - - - - - - - - - - */
    // $(".js-product-accordion").on("click", function () {
    // 	const $this = $(this);
    // 	const $parent = $this.closest(".product-accordion__box");
    // 	const $content = $parent.find(".product-accordion__box-text");
    // 	if (!$parent.hasClass("show")) {
    // 		$(".product-accordion__box").removeClass("show");
    // 		$parent.addClass("show");
    // 		$(".product-accordion__box-text").slideUp(600);
    // 		$content.slideDown(600);
    // 	} else {
    // 		$parent.removeClass("show");
    // 		$content.slideUp(600);
    // 	}
    // });

    /* - - - - - - - - - - - - - -       init faq toggle       - - - - - - - - - - - - - - - */
    // $(".js-faq-toggle").on("click", function () {
    // 	const $this = $(this);
    // 	const $parent = $this.closest(".faq-box");
    // 	if (!$parent.hasClass("show")) {
    // 		$(".faq-box").removeClass("show");
    // 		$parent.addClass("show");
    // 		$(".faq-box__text").slideUp(600);
    // 		$parent.find(".faq-box__text").slideDown(600);
    // 	} else {
    // 		$parent.removeClass("show");
    // 		$parent.find(".faq-box__text").slideUp(600);
    // 	}

    // 	setTimeout(ScrollTrigger.update, 700);
    // });

    const accordions = document.querySelectorAll(".faq-box, .product-accordion__box");
    accordions?.forEach(accordion => {
      const toggle = accordion.querySelector(".js-faq-toggle, .js-product-accordion");
      const body = accordion.querySelector(".faq-box__body, .product-accordion__box-body");
      if (!toggle || !body) return;
      const animateHeight = (el, targetHeight) => {
        const done = () => {
          if (typeof ScrollTrigger !== "undefined") ScrollTrigger.update();
        };
        if (typeof gsap === "undefined") {
          el.style.height = typeof targetHeight === "number" ? targetHeight + "px" : targetHeight;
          done();
          return;
        }
        gsap.to(el, {
          duration: 0.6,
          height: targetHeight,
          ease: "power1.inOut",
          onComplete: done
        });
      };
      toggle.addEventListener("click", e => {
        e.preventDefault();
        let height;
        if (!accordion.classList.contains("show")) {
          accordions?.forEach(el => {
            if (el == accordion) return;
            const elBody = el.querySelector(".faq-box__body, .product-accordion__box-body");
            el.classList.remove("show");
            animateHeight(elBody, 0);
          });
          accordion.classList.add("show");
          body.style.height = "auto";
          height = body.clientHeight + "px";
          body.style.height = "0px";
          animateHeight(body, height);
        } else {
          accordion.classList.remove("show");
          animateHeight(body, 0);
        }
      });
    });

    /* - - - - - - - - - - - - - -       init product gallery slider       - - - - - - - - - - - - - - - */
    // if ($(".product-inner").length) {
    // 	rebuildProduct();
    // 	$(window).on("resize", rebuildProduct);
    // }

    if (document.querySelector(".tabs")) getScrollTabs();
    if (document.querySelector(".catalog-category")) getScrollCategory();
    // Tag lists are handled by tagsObserver; the eager pass here duplicated
    // the full-page layout work a second time at DOM-ready.
    initFitText();
    document.querySelectorAll(".js-other-products-slider").forEach(el => initOtherProductsSlider(el));
    document.querySelectorAll(".js-article-gallery-slider").forEach(el => initArticleGallery(el, "high"));
    initProductGallery("high");
  });
})();
/******/ })()
;